// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMyBookingSessionResponse

export type WidgetMyBookingSessionApiResponse = {
	id: string;
	name: string;
	startAt: number;
	endAt: number;
	activityName: string;
};

export type WidgetMyBookingSession = {
	id: string;
	name: string;
	startAt: number;
	endAt: number;
	activityName: string;
};

export function hydrateWidgetMyBookingSession(data: WidgetMyBookingSessionApiResponse): WidgetMyBookingSession {
	return { ...data };
}